"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _params = require("hub-http/helpers/params");

var _colors = require("HubStyleTokens/colors");

var _FormattedDateTime = _interopRequireDefault(require("I18n/components/FormattedDateTime"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedList = _interopRequireDefault(require("I18n/components/FormattedList"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H3"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIListingPage = _interopRequireDefault(require("UIComponents/page/UIListingPage"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _OpenGraphMeta = _interopRequireDefault(require("ecosystem-marketplace-core/components/elements/OpenGraphMeta"));

var _TwitterMeta = _interopRequireDefault(require("ecosystem-marketplace-core/components/elements/TwitterMeta"));

var _DocumentHead = _interopRequireDefault(require("ecosystem-marketplace-core/components/portals/DocumentHead"));

var _PrerenderReady = _interopRequireDefault(require("ecosystem-marketplace-core/components/prerender/PrerenderReady"));

var GroupTag = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Group"));

var _useWindowDimensionsContext = require("ecosystem-marketplace-core/hooks/useWindowDimensionsContext");

var FilterKey = _interopRequireWildcard(require("../../constants/search/FilterKey"));

var _constants = require("../../constants");

var _StorefrontFilters = _interopRequireDefault(require("../../records/StorefrontFilters"));

var _auth = require("../../selectors/auth");

var _details = require("../../selectors/details");

var _history = require("../../utils/history");

var _useParsedPathParams2 = require("../../utils/hooks/useParsedPathParams");

var _useScrollToTop = require("../../utils/hooks/useScrollToTop");

var _throttle = require("../../utils/throttle");

var _urls = require("../../utils/urls");

var _usageTracker = require("../../utils/usageTracker");

var _zorse = require("../../utils/zorse");

var _CanonicalLink = _interopRequireDefault(require("../elements/CanonicalLink"));

var _MainSection = require("../../components/layout/MainSection");

var _MainSectionInner = _interopRequireDefault(require("../../components/layout/MainSectionInner"));

var _MainSectionHeading = _interopRequireDefault(require("../../components/layout/MainSectionHeading"));

var _InnerSection = _interopRequireDefault(require("../../components/layout/InnerSection"));

var _Header = _interopRequireDefault(require("../../components/detail/Header"));

var _Carousel = _interopRequireDefault(require("../../components/detail/overview/Carousel"));

var _Benefits = _interopRequireDefault(require("../../components/detail/overview/Benefits"));

var _Workings = _interopRequireDefault(require("../../components/detail/overview/Workings"));

var _HubSpotFeatures = _interopRequireDefault(require("../../components/detail/overview/HubSpotFeatures"));

var _AppIntegrations = _interopRequireDefault(require("../../components/detail/overview/AppIntegrations"));

var _AppDetails = _interopRequireDefault(require("../../components/detail/overview/sidebar/AppDetails"));

var _Requirements = _interopRequireDefault(require("../../components/detail/overview/sidebar/Requirements"));

var _Resources = _interopRequireDefault(require("../../components/detail/overview/sidebar/Resources"));

var _Contact = _interopRequireDefault(require("../../components/detail/overview/sidebar/Contact"));

var _Privacy = _interopRequireDefault(require("../../components/detail/overview/sidebar/Privacy"));

var _Permissions = _interopRequireDefault(require("../../components/detail/permissions/Permissions"));

var _Pricings = _interopRequireDefault(require("../../components/detail/pricing/Pricings"));

var _DataSyncs = _interopRequireDefault(require("../../components/detail/dataSyncs/DataSyncs"));

var _Reviews = _interopRequireDefault(require("../../components/detail/reviews/Reviews"));

var _ReviewWizard = _interopRequireDefault(require("../../components/detail/reviews/ReviewWizard"));

var _MoreApps = _interopRequireDefault(require("../../components/detail/MoreApps"));

var _ReviewsActions = require("../../actions/ReviewsActions");

var CATEGORY = FilterKey.CATEGORY,
    SUPER_CATEGORY = FilterKey.SUPER_CATEGORY;
var AsyncCtaBanner = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: 'detail-cta-banner' */
    './CtaBanner');
  }
});

var SidebarSection = function SidebarSection(props) {
  return _react.default.createElement(_InnerSection.default, (0, _extends3.default)({}, props, {
    compact: true
  }));
};

var InnerSectionHeading = function InnerSectionHeading(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_H.default, {
    className: "is--heading-4"
  }, children);
};

var DetailPage = function DetailPage(_ref2) {
  var isAdminPreview = _ref2.isAdminPreview;

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname,
      search = _useLocation.search;

  var params = (0, _reactRouterDom.useParams)();

  var _useRouteMatch = (0, _reactRouterDom.useRouteMatch)(),
      path = _useRouteMatch.path,
      url = _useRouteMatch.url;

  var _useWindowDimensionsC = (0, _useWindowDimensionsContext.useWindowDimensionsContext)(),
      windowHeight = _useWindowDimensionsC.height;

  (0, _useScrollToTop.useScrollToTop)(pathname);

  var _useParsedPathParams = (0, _useParsedPathParams2.useParsedPathParams)(params),
      activeCategory = _useParsedPathParams.category,
      activeSuperCategory = _useParsedPathParams.superCategory,
      slug = _useParsedPathParams.slug;

  var getListingView = (0, _details.makeGetListingView)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var hasZorseChatScope = (0, _reactRedux.useSelector)(_auth.getHasZorseChatScope);
  var hasZorseWebticketScope = (0, _reactRedux.useSelector)(_auth.getHasZorseWebticketScope);
  var isCustomer = (0, _reactRedux.useSelector)(_auth.getIsCustomer);
  var isUngatedForRemovePieSyncConnectorInstallCount = (0, _reactRedux.useSelector)(_auth.getIsUngatedForRemovePieSyncConnectorInstallCount);
  var listingView = (0, _reactRedux.useSelector)(function (state) {
    return getListingView(state, {
      slug: slug
    });
  });

  var _parseParams = (0, _params.parse)(search.slice(1)),
      published = _parseParams.published,
      rating = _parseParams.rating,
      source = _parseParams.source;

  var isPreview = published === 'false' || path === '/_preview/:slug' || isAdminPreview;
  var isReviewLink = path.includes('/:slug/write-review');
  var overallRating = /^[1-5]$/.test(rating) ? parseInt(rating, 10) : undefined;
  var tracker = (0, _usageTracker.getUsageTracker)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      pageViewTracked = _useState2[0],
      setPageViewTracked = _useState2[1];

  var _useState3 = (0, _react.useState)(isReviewLink),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      wizardOpen = _useState4[0],
      setWizardOpen = _useState4[1];

  var listingCategory = (0, _react.useMemo)(function () {
    return activeCategory || listingView.getCategory() || null;
  }, [activeCategory, listingView]);
  var listingSuperCategory = (0, _react.useMemo)(function () {
    return activeSuperCategory || listingView.getSuperCategory() || null;
  }, [activeSuperCategory, listingView]);
  var headerRef = (0, _react.useRef)(null);
  var overviewRef = (0, _react.useRef)(null);
  var pricingRef = (0, _react.useRef)(null);
  var dataRef = (0, _react.useRef)(null);
  var reviewsRef = (0, _react.useRef)(null);

  var _useState5 = (0, _react.useState)('overview'),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      activeTab = _useState6[0],
      setActiveTab = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      tabClicked = _useState8[0],
      setTabClicked = _useState8[1];

  var calculateVisibleSection = (0, _throttle.throttle)((0, _react.useCallback)(function () {
    var headerEl = (0, _reactDom.findDOMNode)(headerRef.current);
    var pricingEl = (0, _reactDom.findDOMNode)(pricingRef.current);
    var dataEl = (0, _reactDom.findDOMNode)(dataRef.current);
    var reviewsEl = (0, _reactDom.findDOMNode)(reviewsRef.current);

    if (headerEl && !tabClicked) {
      var scroll = window.scrollY - headerEl.offsetHeight + (windowHeight - _constants.NAV_BAR_HEIGHT_INT) / 2;

      if (reviewsEl && scroll > reviewsEl.offsetTop) {
        setActiveTab('reviews');
      } else if (dataEl && scroll > dataEl.offsetTop) {
        setActiveTab('data-permissions');
      } else if (pricingEl && scroll > pricingEl.offsetTop) {
        setActiveTab('pricing');
      } else {
        setActiveTab('overview');
      }
    }
  }, [tabClicked, windowHeight]));
  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', calculateVisibleSection);
    return function () {
      return window.removeEventListener('scroll', calculateVisibleSection);
    };
  }, [calculateVisibleSection]);
  var agencyPricingUrl = listingView.agencyPricingUrl,
      appUrl = listingView.appUrl,
      benefits = listingView.benefits,
      casesUrl = listingView.casesUrl,
      chatUrl = listingView.chatUrl,
      companyName = listingView.companyName,
      companyUrl = listingView.companyUrl,
      dataSyncInfo = listingView.dataSyncInfo,
      dataSyncs = listingView.dataSyncs,
      email = listingView.email,
      facebookUrl = listingView.facebookUrl,
      forumUrl = listingView.forumUrl,
      groupTags = listingView.groupTags,
      iconUrl = listingView.iconUrl,
      id = listingView.id,
      installability = listingView.installability,
      name = listingView.name,
      _listingView$offering = listingView.offering,
      homemade = _listingView$offering.homemade,
      certifiedAt = _listingView$offering.certifiedAt,
      offeringId = listingView.offeringId,
      phone = listingView.phone,
      pricingUrl = listingView.pricingUrl,
      pricings = listingView.pricings,
      privacy2Url = listingView.privacy2Url,
      privacy3Url = listingView.privacy3Url,
      privacyUrl = listingView.privacyUrl,
      requiredScopeGroups = listingView.requiredScopeGroups,
      reviewability = listingView.reviewability,
      reviewSummary = listingView.reviewSummary,
      screenshots = listingView.screenshots,
      socialScreenshots = listingView.socialScreenshots,
      setupUrl = listingView.setupUrl,
      supportUrl = listingView.supportUrl,
      tagline = listingView.tagline,
      termsUrl = listingView.termsUrl,
      updatedAt = listingView.updatedAt,
      _listingView$version = listingView.version,
      connectionType = _listingView$version.connectionType,
      hubInstalls = _listingView$version.hubInstalls,
      hubspotPolicy = _listingView$version.hubspotPolicy,
      videoUrl = listingView.videoUrl,
      workings = listingView.workings;
  var categoryFeatures = groupTags.get(GroupTag.CATEGORY_FEATURES);
  var keywords = groupTags.get(GroupTag.KEYWORDS);
  var integrations = groupTags.get(GroupTag.APP_INTEGRATIONS);
  var supportLanguages = groupTags.get(GroupTag.SUPPORT_LANGUAGES);
  var tiers = groupTags.get(GroupTag.TIERS);
  var hubspotFeatures = groupTags.get(GroupTag.HUBSPOT_FEATURES);
  var appId = listingView.getAppId();
  var isPieSyncConnector = listingView.getIsPieSyncConnector();
  var hubInstallable = installability.hubInstallable,
      nonTrialHubInstallable = installability.nonTrialHubInstallable;
  var metaDescription = (0, _react.useMemo)(function () {
    if (isPieSyncConnector) {
      return (0, _unescapedText.default)('appMarketplace.pieSyncConnector.metaDescription', {
        name: name
      });
    }

    return tagline;
  }, [isPieSyncConnector, name, tagline]);
  var metaImageUrl = (0, _react.useMemo)(function () {
    return socialScreenshots.get('img1200x630') || screenshots.getIn([0, 'imageUrl']);
  }, [socialScreenshots, screenshots]);
  var documentTitle = (0, _react.useMemo)(function () {
    if (isPieSyncConnector) {
      return (0, _unescapedText.default)('appMarketplace.pieSyncConnector.htmlTitle', {
        name: name
      });
    }

    return (0, _unescapedText.default)('appMarketplace.detail.htmlTitle', {
      name: name
    });
  }, [isPieSyncConnector, name]);
  var eventProperties = (0, _react.useMemo)(function () {
    var screen;

    if (isPreview) {
      screen = 'detail preview';
    } else if (isReviewLink) {
      screen = 'detail review';
    } else {
      screen = 'detail';
    }

    return (0, _extends3.default)({}, listingView.getEventProperties(), {
      screen: screen
    });
  }, [isPreview, isReviewLink, listingView]);
  var trackConnectButtonClick = (0, _react.useCallback)(function () {
    tracker.track('listing-detail-click-connect', eventProperties);
  }, [tracker, eventProperties]);
  var trackInteraction = (0, _react.useCallback)(function (action, section, value) {
    var properties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    tracker.track('listing-detail-interaction', (0, _extends3.default)({
      action: action,
      section: section,
      value: value
    }, properties, eventProperties));
  }, [tracker, eventProperties]);
  var pricingLastUpdated = (0, _react.useMemo)(function () {
    if (pricings.first() && pricings.first().updatedAt) {
      return pricings.first().updatedAt;
    }

    return updatedAt;
  }, [pricings, updatedAt]);
  var getFilterLink = (0, _react.useCallback)(function (filterKey, tagName) {
    var _extends2;

    var isAllCategories = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var filters = _StorefrontFilters.default.from((0, _extends3.default)({}, filterKey && (0, _defineProperty2.default)({}, filterKey, [tagName]), (_extends2 = {}, (0, _defineProperty2.default)(_extends2, CATEGORY, listingCategory), (0, _defineProperty2.default)(_extends2, SUPER_CATEGORY, listingSuperCategory), _extends2)));

    if (isAllCategories) {
      filters = filters.toAllCategories();
    }

    return filters.toLocation();
  }, [listingCategory, listingSuperCategory]);
  (0, _react.useEffect)(function () {
    document.title = documentTitle;

    if (!pageViewTracked) {
      var eventName;

      if (isPreview) {
        eventName = 'listing-detail-preview-pageview';
      } else if (isReviewLink) {
        eventName = 'listing-detail-review-pageview';
      } else {
        eventName = 'listing-detail-pageview';
      }

      tracker.track(eventName, (0, _extends3.default)({}, eventProperties, {
        source: source
      }));
      setPageViewTracked(true);
    }
  }, [documentTitle, eventProperties, isPreview, isReviewLink, pageViewTracked, source, tracker]);
  return _react.default.createElement(_react.Fragment, null, isPreview && !isAdminPreview && _react.default.createElement(_UIAlert.default, {
    titleText: (0, _unescapedText.default)('appMarketplace.detail.previewAlert.titleText'),
    type: "warning"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.previewAlert.message"
  })), _react.default.createElement(_UIListingPage.default, {
    contentAreaFlush: true,
    headerComponent: _react.default.createElement(_NavMarker.default, {
      name: "DETAIL_HEADER_LOAD"
    }, _react.default.createElement(_MainSectionInner.default, {
      ref: headerRef
    }, _react.default.createElement(_Header.default, {
      activeTab: activeTab,
      appId: appId,
      appName: name,
      appUrl: appUrl,
      category: listingCategory,
      certifiedAt: certifiedAt,
      connectionType: connectionType,
      iconUrl: iconUrl,
      installability: installability,
      isCustomer: isCustomer,
      isPieSyncConnector: isPieSyncConnector,
      isPreview: isPreview,
      listingId: id,
      onConnectButtonClick: trackConnectButtonClick,
      onTrackInteraction: trackInteraction,
      reviewSummary: reviewSummary,
      setActiveTab: setActiveTab,
      setTabClicked: setTabClicked,
      setupUrl: setupUrl,
      slug: slug,
      superCategory: listingSuperCategory,
      tagline: tagline
    }))),
    mainSectionBackgroundColor: _colors.OLAF,
    pageBackgroundColor: _colors.GYPSUM,
    pageLayout: "full-width"
  }, _react.default.createElement(_MainSection.DetailMainSection, {
    id: "overview",
    ref: overviewRef
  }, _react.default.createElement(_MainSectionInner.default, null, _react.default.createElement(_MainSectionHeading.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.headingText",
    options: {
      name: name
    }
  })), _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 12,
      md: 8
    }
  }, _react.default.createElement(_InnerSection.default, null, _react.default.createElement(_Carousel.default, {
    onTrackInteraction: trackInteraction,
    screenshots: screenshots,
    videoUrl: videoUrl
  })), _react.default.createElement(_InnerSection.default, null, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.benefits.headingText"
  })), _react.default.createElement(_Benefits.default, {
    benefits: benefits
  })), _react.default.createElement(_InnerSection.default, null, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.workings.headingText",
    options: {
      name: name
    }
  })), _react.default.createElement(_Workings.default, {
    onTrackInteraction: trackInteraction,
    workings: workings
  })), _react.default.createElement(_InnerSection.default, null, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.hubspotFeatures.headingText",
    options: {
      name: name
    }
  })), _react.default.createElement(_HubSpotFeatures.default, {
    hubspotFeatures: hubspotFeatures,
    getFilterLink: getFilterLink,
    isPreview: isPreview
  })), !integrations.isEmpty() && _react.default.createElement(_InnerSection.default, null, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.appIntegrations.headingText",
    options: {
      name: name
    }
  })), _react.default.createElement(_AppIntegrations.default, {
    integrations: integrations
  }))), _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 12,
      md: 4
    }
  }, _react.default.createElement(SidebarSection, null, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.sidebar.details.headingText"
  })), _react.default.createElement(_AppDetails.default, {
    category: listingCategory,
    categoryFeatures: categoryFeatures,
    companyName: companyName,
    companyUrl: companyUrl,
    getFilterLink: getFilterLink,
    installs: hubInstalls,
    isPieSyncConnector: isPieSyncConnector,
    isPreview: isPreview,
    isUngatedForRemovePieSyncConnectorInstallCount: isUngatedForRemovePieSyncConnectorInstallCount,
    onTrackInteraction: trackInteraction
  })), _react.default.createElement(SidebarSection, null, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.sidebar.requirements.headingText"
  })), _react.default.createElement(_Requirements.default, {
    appName: name,
    companyName: companyName,
    homemade: homemade,
    hubInstallable: hubInstallable,
    nonTrialHubInstallable: nonTrialHubInstallable,
    onTrackInteraction: trackInteraction,
    pricingUrl: pricingUrl,
    pricings: pricings,
    tiers: tiers
  })), _react.default.createElement(SidebarSection, null, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.sidebar.resources.headingText"
  })), _react.default.createElement(_Resources.default, {
    casesUrl: casesUrl,
    forumUrl: forumUrl,
    onTrackInteraction: trackInteraction,
    setupUrl: setupUrl,
    supportUrl: supportUrl
  })), _react.default.createElement(SidebarSection, null, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_UIHelpIcon.default, {
    size: 14,
    title: _react.default.createElement(_FormattedReactMessage.default, {
      message: "appMarketplace.detail.overview.sidebar.contact.supportedLanguagesTooltip",
      options: {
        languages: _react.default.createElement(_FormattedList.default, null, supportLanguages.map(function (languageCode) {
          return [languageCode, "SharedI18nStrings.languageNames." + languageCode];
        }).sortBy(function (_ref4) {
          var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
              __ = _ref5[0],
              languageNameI18nKey = _ref5[1];

          return (0, _unescapedText.default)(languageNameI18nKey);
        }).map(function (_ref6) {
          var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
              languageCode = _ref7[0],
              languageNameI18nKey = _ref7[1];

          return _react.default.createElement(_FormattedMessage.default, {
            key: languageCode,
            message: languageNameI18nKey
          });
        }).toArray())
      }
    })
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.sidebar.contact.headingText",
    options: {
      companyName: companyName
    }
  }))), _react.default.createElement(_Contact.default, {
    chatUrl: chatUrl,
    companyUrl: companyUrl,
    email: email,
    facebookUrl: facebookUrl,
    hasZorseChatScope: hasZorseChatScope,
    hasZorseWebticketScope: hasZorseWebticketScope,
    homemade: homemade,
    isCustomer: isCustomer,
    onTrackInteraction: trackInteraction,
    openHelpWidget: _zorse.openHelpWidget,
    phone: phone
  })), _react.default.createElement(SidebarSection, null, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.overview.sidebar.privacy.headingText"
  })), _react.default.createElement(_Privacy.default, {
    hubspotPolicy: hubspotPolicy,
    onTrackInteraction: trackInteraction,
    privacyUrl: privacyUrl,
    privacy2Url: privacy2Url,
    privacy3Url: privacy3Url,
    termsUrl: termsUrl
  })), isCustomer && hasZorseWebticketScope && _react.default.createElement(_react.Fragment, null, _react.default.createElement(_HR.default, {
    distance: "medium"
  }), _react.default.createElement(SidebarSection, null, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "appMarketplace.detail.overview.sidebar.reportApp_jsx",
    options: {
      onClick: function onClick() {
        trackInteraction('click report this app link', 'report');
        (0, _zorse.openHelpWidget)({
          create: true
        });
      }
    },
    elements: {
      Link: _UILink.default
    }
  }))))))), _react.default.createElement(_MainSection.DetailMainSection, {
    color: "light",
    id: "pricing",
    ref: pricingRef
  }, _react.default.createElement(_MainSectionInner.default, null, _react.default.createElement(_MainSectionHeading.default, {
    itemRight: _react.default.createElement(_react.Fragment, null, agencyPricingUrl && _react.default.createElement(_UIButton.default, {
      external: true,
      href: (0, _urls.getFormattedUrl)(agencyPricingUrl),
      onClick: function onClick() {
        return trackInteraction('click agency pricing link', 'pricing');
      },
      use: "link"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.detail.pricing.agencyPricingLinkText"
    })), pricingUrl && _react.default.createElement(_UIButton.default, {
      external: true,
      href: (0, _urls.getFormattedUrl)(pricingUrl),
      onClick: function onClick() {
        return trackInteraction('click software pricing link', 'pricing');
      },
      use: "link"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.detail.pricing.pricingLinkText"
    }))),
    subheading: _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.detail.pricing.subheadingText",
      options: {
        name: isPieSyncConnector ? companyName : name
      }
    })
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.pricing.headingText",
    options: {
      name: isPieSyncConnector ? companyName : name
    }
  })), _react.default.createElement("div", null, _react.default.createElement(_Pricings.default, {
    onTrackInteraction: trackInteraction,
    pricings: pricings
  })), _react.default.createElement("div", null, _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "appMarketplace.detail.pricing.disclaimerText_jsx",
    elements: {
      b: 'b',
      Date: _FormattedDateTime.default
    },
    options: {
      format: 'L',
      type: isCustomer ? 'portalTz' : 'utc',
      value: pricingLastUpdated
    }
  }))))), _react.default.createElement(_MainSection.DetailMainSection, {
    id: "data-permissions",
    ref: dataRef
  }, _react.default.createElement(_MainSectionInner.default, null, _react.default.createElement(_MainSectionHeading.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.dataPermissions.headingText"
  })), _react.default.createElement(_InnerSection.default, null, _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 12,
      md: 6
    }
  }, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.dataPermissions.dataSyncs.headingText"
  })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.dataPermissions.dataSyncs.subheadingText",
    options: {
      name: name
    }
  })), _react.default.createElement(_DataSyncs.default, {
    dataSyncInfo: dataSyncInfo,
    dataSyncs: dataSyncs,
    iconUrl: iconUrl,
    name: name,
    onTrackInteraction: trackInteraction
  })), _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 12,
      md: 6
    }
  }, _react.default.createElement(InnerSectionHeading, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.dataPermissions.permissions.headingText"
  })), _react.default.createElement(_Permissions.default, {
    connectionType: connectionType,
    homemade: homemade,
    requiredScopeGroups: requiredScopeGroups
  })))))), _react.default.createElement(_MainSection.DetailMainSection, null, _react.default.createElement(_MainSectionInner.default, {
    id: "reviews",
    ref: reviewsRef,
    divider: true
  }, _react.default.createElement(_UISection.default, null, _react.default.createElement(_Reviews.default, {
    appName: name,
    category: listingCategory,
    isPreview: isPreview,
    offeringId: offeringId,
    onWriteReviewClick: function onWriteReviewClick() {
      return setWizardOpen(true);
    },
    reviewability: reviewability,
    slug: slug
  })))), !isCustomer && _react.default.createElement(_MainSection.DetailMainSection, {
    color: "dark"
  }, _react.default.createElement(_InnerSection.default, null, _react.default.createElement(AsyncCtaBanner, {
    appName: name,
    appLink: pricingUrl,
    companyName: companyName,
    companyUrl: companyUrl,
    homemade: homemade,
    pathname: pathname,
    onTrackInteraction: trackInteraction
  }))), _react.default.createElement(_MoreApps.default, {
    category: listingCategory,
    superCategory: listingSuperCategory,
    slug: slug,
    trackInteraction: trackInteraction
  }), wizardOpen && _react.default.createElement(_ReviewWizard.default, {
    appName: name,
    appIcon: iconUrl,
    offeringId: offeringId,
    onClose: function onClose() {
      return setWizardOpen(false);
    },
    onSuccess: function onSuccess() {
      setWizardOpen(false);
      (0, _history.replace)((0, _urls.getListingDetailUrl)(slug, listingCategory));
      dispatch((0, _ReviewsActions.resetReviewsFetch)());
      dispatch((0, _ReviewsActions.resetReviewsStatsFetch)());
    },
    onTrackInteraction: trackInteraction,
    overallRating: overallRating,
    reviewability: reviewability
  })), _react.default.createElement(_auth.PublicOnly, null, _react.default.createElement(_DocumentHead.default, null, _react.default.createElement(_CanonicalLink.default, {
    to: url
  }), _react.default.createElement("meta", {
    name: "description",
    content: metaDescription
  }), _react.default.createElement("meta", {
    name: "keywords",
    content: keywords.join(',')
  }), _react.default.createElement(_TwitterMeta.default, {
    name: "card"
  }), _react.default.createElement(_TwitterMeta.default, {
    name: "site"
  }), _react.default.createElement(_TwitterMeta.default, {
    name: "image",
    content: metaImageUrl
  }), _react.default.createElement(_OpenGraphMeta.default, {
    property: "type"
  }), _react.default.createElement(_OpenGraphMeta.default, {
    property: "url",
    content: (0, _history.getFullHref)(url)
  }), _react.default.createElement(_OpenGraphMeta.default, {
    property: "title"
  }), _react.default.createElement(_OpenGraphMeta.default, {
    property: "description",
    content: metaDescription
  }), _react.default.createElement(_OpenGraphMeta.default, {
    property: "image",
    content: metaImageUrl
  }), _react.default.createElement(_PrerenderReady.default, null))));
};

DetailPage.propTypes = {
  isAdminPreview: _propTypes.default.bool.isRequired
};
DetailPage.defaultProps = {
  isAdminPreview: false
};
var _default = DetailPage;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/DetailPage.js
// module id = 380
// module chunks = 209 210 211 212